import { render } from "./readBookInfo.vue?vue&type=template&id=12928bff&scoped=true"
import script from "./readBookInfo.vue?vue&type=script&lang=js"
export * from "./readBookInfo.vue?vue&type=script&lang=js"

import "./readBookInfo.vue?vue&type=style&index=0&id=12928bff&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12928bff"]])

export default __exports__